import { ACCOUNT_PROPERTY_MODAL_FORM_RESET, CREATE_ACCOUNT_PROPERTYS_MODAL_FAILURE, CREATE_ACCOUNT_PROPERTYS_MODAL_REQUEST, CREATE_ACCOUNT_PROPERTYS_MODAL_SUCCESS, CREATE_USER_FORM_ACCOUNT_PROPERTY_MODAL, FETCH_ACCOUNT_PROPERTY_MODAL_LIST_SUCCESS, FETCH_ACCOUNT_PROPERTYS_MODAL_SUCCESS } from "./AccountPropertyModal.actionType";


export const ACCOUNT_PROPERTY_MODAL = 'accountPropertyModal';

let initialState = {
    loading: false,
    isForceLogout: false,
    accountPropertyModalUserform: {},
    accountPropertyModalList: [],
    Department: [],
    RequestorName: [],
    ToPayee: [],
    Purpose: [],
    errorMessage: '',
}

export let accountPropertyModalReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_ACCOUNT_PROPERTYS_MODAL_REQUEST:
            return {
                ...state,
                loading: true
            };
        // case FETCH_ACCOUNT_PROPERTYS_MODAL_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         accountPropertyModalList: updatePayload,
        //         // detailsId: updatePayload
        //     };
        // case FETCH_ACCOUNT_PROPERTY_MODAL_LIST_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         accountPropertyModalList: updatePayload,
        //     };

        case FETCH_ACCOUNT_PROPERTY_MODAL_LIST_SUCCESS:
            switch (payload) {
                case 'Department':
                    return {
                        ...state,
                        loading: false,
                        Department: updatePayload
                    };
                case 'RequestorName':
                    return {
                        ...state,
                        loading: false,
                        RequestorName: updatePayload
                    };
                case 'ToPayee':
                    return {
                        ...state,
                        loading: false,
                        ToPayee: updatePayload
                    };
                case 'Purpose':
                    return {
                        ...state,
                        loading: false,
                        Purpose: updatePayload
                    };
                default:
                    return { ...state, loading: false };
            }


        case CREATE_USER_FORM_ACCOUNT_PROPERTY_MODAL:
            return {
                ...state,
                loading: false,
                accountPropertyModalUserform: {
                    ...state.accountPropertyModalUserform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_ACCOUNT_PROPERTYS_MODAL_SUCCESS:
            return {
                ...state,
                loading: false,
                accountPropertyModalUserform: updatePayload,
            }
        case CREATE_ACCOUNT_PROPERTYS_MODAL_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case ACCOUNT_PROPERTY_MODAL_FORM_RESET:
            return {
                ...state,
                accountPropertyModalUserform: {}
            };
        default:
            return { ...state, loading: false };
    }
}